export const getSwitchFormattedValue = (value: boolean): string => {
  return value ? 'True' : 'False';
}
